import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { ITeamMast, Table } from "./Table";
import { IPermissionProps } from "../../models/Login";
import { EmptyTeam, TeamData, teamData } from "./EmptyTeam";
import { TeamMembersForm } from "./TeamMembersForm";
import { MoveTeamMembersForm } from "./MoveTeamMembersForm";
import { ITeamManagement } from "../../models/TeamManagement";

export interface IModel {
    open: boolean,
    singleData: ITeamManagement,
    teamNameList: ITeamMast[]
}

export interface IModel2 {
    open: boolean,
    singleData: teamData
}

export interface IModel3 {
    open: boolean,
    singleData: teamData[],
    inTeam: teamData,
}

export const TeamManagement = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTeam, open: false, teamNameList: [] } as IModel);
    const [modal2,setModal2] = useState({ singleData: TeamData, open: false } as IModel2);
    const [modal3,setModal3] = useState({ singleData: [], open: false, inTeam:{} } as IModel3);
    const [reload, setReload] = useState(false);
    const [reload2, setReload2] = useState(false);
    const [reload3, setReload3] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyTeam, open: false, teamNameList: [] })
    };
    const hideDialog2 = () => {
        setModal2({ singleData: TeamData, open: false })
    };
    const hideDialog3 = () => {
        setModal3({ singleData: [], open: false, inTeam: TeamData })
    };

    return (
        <>
            {(permissions.is_Create || permissions.is_Update) && <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} teamNameList={modal.teamNameList}></Form>}
            <TeamMembersForm singleData={modal2.singleData} open={modal2.open} hideDialog={hideDialog2} toast={toast} reload={reload2} setReload={setReload2} setModal={setModal} setModal3={setModal3}></TeamMembersForm>
            <MoveTeamMembersForm singleData={modal3.singleData} open={modal3.open} hideDialog={hideDialog3} toast={toast} reload={reload3} setReload={setReload3} inTeam={modal3.inTeam} setModal={setModal2}></MoveTeamMembersForm>
            <Table permissions={permissions} setModal={setModal} setModal2={setModal2} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}
